"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBasePage = exports.isGameDetailsPage = exports.isLiveEventPage = exports.isVODPlaylistPage = exports.isTeamHubsPage = exports.isLatestPage = exports.isWebWatchPage = exports.isWebPage = exports.isWatchPage = exports.isScoresPage = exports.isMorePage = exports.isAccountPage = void 0;
var _abstract_1 = require("./_abstract");
var isAccountPage = function (component) {
    return component.type === _abstract_1.ComponentType.AccountPage;
};
exports.isAccountPage = isAccountPage;
var isMorePage = function (component) {
    return component.type === _abstract_1.ComponentType.MorePage;
};
exports.isMorePage = isMorePage;
var isScoresPage = function (component) {
    return component.type === _abstract_1.ComponentType.ScoresPage;
};
exports.isScoresPage = isScoresPage;
var isWatchPage = function (component) {
    return component.type === _abstract_1.ComponentType.WatchPage;
};
exports.isWatchPage = isWatchPage;
var isWebPage = function (component) {
    return component.type === _abstract_1.ComponentType.WebPage;
};
exports.isWebPage = isWebPage;
var isWebWatchPage = function (component) {
    return component.type === _abstract_1.ComponentType.WebWatchPage;
};
exports.isWebWatchPage = isWebWatchPage;
var isLatestPage = function (component) {
    return component.type === _abstract_1.ComponentType.LatestPage;
};
exports.isLatestPage = isLatestPage;
var isTeamHubsPage = function (component) {
    return component.type === _abstract_1.ComponentType.TeamPage;
};
exports.isTeamHubsPage = isTeamHubsPage;
var isVODPlaylistPage = function (component) {
    return component.type === _abstract_1.ComponentType.VodPage;
};
exports.isVODPlaylistPage = isVODPlaylistPage;
var isLiveEventPage = function (component) {
    return component.type === _abstract_1.ComponentType.LiveEventPage;
};
exports.isLiveEventPage = isLiveEventPage;
var isGameDetailsPage = function (component) {
    return component.type === _abstract_1.ComponentType.GameDetailsPage;
};
exports.isGameDetailsPage = isGameDetailsPage;
var isBasePage = function (component) {
    return component.type === _abstract_1.ComponentType.Page;
};
exports.isBasePage = isBasePage;
